
import {
    getSimpleList as simple_currency_list
} from "@/api/currency"
export default {
    emits: [
        'done',
        'update:visible'
    ],
    props: {
        // 弹窗是否打开
        visible: Boolean,
        // 分组ID
        groupid: Number,
        // 修改回显的数据
        data: Object
    },
    data() {
        return {
            // 表单数据
            form: Object.assign({
                currency: '',
                fee_types: 1
            }, this.data),
            // 表单验证规则
            rules: {
                ship_method_id: [{
                    required: true,
                    message: this.$t('必填'),
                    type: 'string',
                    trigger: 'blur'
                }],
                fee_types: [{
                    required: true,
                    message: this.$t('必填'),
                    type: 'number',
                    trigger: 'cahnge'
                }],
                charge_name: [{
                    required: true,
                    message: this.$t('必填'),
                    type: 'string',
                    trigger: 'blur'
                }],
                value_script: [{
                    required: true,
                    message: this.$t('必填'),
                    type: 'string',
                    trigger: 'blur'
                }],
                calc_index: [{
                    required: true,
                    message: this.$t('必填'),
                    type: 'number',
                    trigger: 'blur'
                }],
                currency: [{
                    required: true,
                    message: this.$t('必填'),
                    type: 'string',
                    trigger: 'cahnge',
                    validator(rule, value) {
                        if (value === undefined) {
                            return Promise.reject(this.$t('必填'))
                        }

                        return Promise.resolve();
                    }
                }]
            },
            // 提交状态
            loading: false,
            // 是否是修改
            isUpdate: false,
            // 物流渠道列表
            ship_methods: [],
            // 币种列表
            currency_list: [],
            // 供应商列表
            supplier_list: []
        };
    },
    watch: {
        data() {
            if (this.data) {

                if (!this.data.currency) {
                    this.form = Object.assign({}, this.data, {
                        currency: ''
                    });
                } else {
                    this.form = Object.assign({}, this.data);
                }

                this.form.ship_method_id = this.form.ship_method_id.toString();
                this.isUpdate = true;
            } else {
                this.form = {
                    calc_index: 1,
                    currency: '',
                    fee_types: 1
                };
                this.isUpdate = false;
            }
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        }
    },
    created() {
        simple_currency_list().then(data => {
            this.currency_list = data;
        })
    },
    mounted() {
        this.load_ship_methods();
        this.getSupplier();
    },
    activated() {
        this.getSupplier();
    },
    methods: {
        load_ship_methods() {
            this.$http.get('/admin/ship_method/simple_list').then(res => {
                if (res.data.code === 0) {
                    this.ship_methods = res.data.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            }).catch(e => {
                this.$message.error(e.message);
            });
        },
        /* 更新visible */
        updateVisible(value) {
            this.$emit('update:visible', value);
        },
        /* 保存编辑 */
        save() {
            this.$refs.form.validate().then(() => {
                this.loading = true;
                this.$http.post(`/admin/charge_group_surcharge/update/${this.groupid}`, Object.assign({}, this.form)).then(res => {
                    this.loading = false;
                    if (res.data.code === 0) {
                        this.$message.success(res.data.msg);
                        if (!this.isUpdate) {
                            this.form = {
                                currency: '',
                                fee_types: 1
                            };
                        }
                        this.updateVisible(false);
                        this.$emit('done');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
            }).catch(() => {});
        },
        onClose() {
            this.updateVisible(false);
        },
        handleFilter(input, option) {
            return option.text.includes(input) || option.value.includes(input)
        },
        /**
         * 获取供应商
         */
        getSupplier() {
            this.$http.get("/admin/supplier/list", {
                params: {
                    limit: 999,
                    page: 1
                }
            }).then(res => {
                if (res.data.code === 0) {
                    this.supplier_list = res.data.data;
                }
            })
        }
    }
}
